/*
    Create by fanglijuan 2016-10-17
*/
'use strict';
angular.module("createOtherConfigurationModule", [])
    .controller("createOtherConfigurationCtrl", ["$scope", "$timeout", "$q", "$validation", "trsHttpService", '$modalInstance', "otherConfigurationService", "trsspliceString", "modalDialog", "otherConfig",
        function($scope, $timeout, $q, $validation, trsHttpService, $modalInstance, otherConfigurationService, trsspliceString, modalDialog, otherConfig) {
            initStatus();
            /**
             * [initStatus description]初始化参数
             */
            function initStatus() {
                $scope.data = {
                    currOtherConfig: otherConfig ? angular.copy(otherConfig) : '',
                };
                $scope.status = {
                    modalTitle: otherConfig ? "编辑其他配置" : "新建其他配置",
                    isCreate: otherConfig ? false : true,
                };
            }

            //确定
            $scope.confirm = function() {
                $validation.validate($scope.createOtherConfigSubmitForm).success(function() {
                    saveOtherConfig($scope.data.currOtherConfig).then(function(data) {
                        modalDialog.alertType('保存成功', "", "success", false, function() {
                            $modalInstance.close(data);
                        });
                    });
                }).error(function() {
                    modalDialog.alertType('保存失败', "请检查填写项", "warning", false);
                });
            };
            //取消
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };

            function saveOtherConfig(currOtherConfig) {
                var defer = $q.defer();
                var params = {
                    serviceid: "mlf_usersysconfig",
                    methodname: "saveUserSysConfig",
                    ConfigId: otherConfig ? $scope.data.currOtherConfig.CONFIGID : 0,
                    CKEY: currOtherConfig.CKEY,
                    CVALUE: currOtherConfig.CVALUE,
                    CDESC: currOtherConfig.CDESC,
                    /*CTYPE: 20,//默认类型：否
                    ENCRYPTED: 0//默认加密方式：否*/
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                    data = data.replace(/\"/g, "");
                    defer.resolve(data);
                });
                return defer.promise;
            }
        }
    ]);
